var _defs, _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .d {\n        fill: url(#c);\n      }\n\n      .e {\n        fill: url(#b);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 8.3,
    y1: 32.39,
    x2: 11.56,
    y2: 28.35,
    gradientTransform: "translate(0 44) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.86,
    y1: 39.31,
    x2: 10.84,
    y2: 34.45,
    xlinkHref: "#b"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M13.47,14.21L6.08,4.69h-1.39v6.62h1.11v-5.2l6.79,8.78c.31-.21.6-.43.87-.67Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 10.3,
    y: 4.69,
    width: 1.1,
    height: 6.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNextjs);
export default __webpack_public_path__ + "static/media/logo-nextjs.4a397345a224f6e5ba822179fa7325f1.svg";
export { ForwardRef as ReactComponent };